// extracted by mini-css-extract-plugin
module.exports = {"CollectionsPage":"CollectionsPage_CollectionsPage___mbSm","Title":"CollectionsPage_Title__DMCaz","Collections":"CollectionsPage_Collections__U_qxm"};